jQuery(document).ready(function () {
    let pricingToggle = document.getElementById('pricing-toggle-checkbox')
    let packageDropdown = document.getElementById('package-levels-dropdown')

    if (typeof pricingToggle != 'undefined' && pricingToggle != null) {
        getAdminAjax("get_packages")
            .then((response) => {
                // console.log(JSON.parse(response))
                let parsed = JSON.parse(response)

                if (typeof packageDropdown != 'undefined' && packageDropdown != null) {
                    createDropdownOptions(parsed);
                    packageDropdown.disabled = false;
                } else {
                    document.getElementById('input_5_30').addEventListener('change', function () {
                        updatePricing(parsed)
                    })
                }

                updateStartingPrice(parsed)

                pricingToggle.addEventListener("keydown", (event) => {
                    if (event.key === "Enter" || event.key === "ArrowRight" || event.key === "ArrowLeft") {
                        pricingToggle.checked = !pricingToggle.checked;
                        toggleMonthly(parsed, event)
                    }
                });
                function simulateClick(element) {
                    if (element) {
                      // Create a new MouseEvent
                      const event = new MouseEvent('click', {
                        bubbles: true, // Allow event to bubble up the DOM
                        cancelable: true, // Allow event to be canceled
                        view: window // Set the view to the current window
                      });
                  
                      // Dispatch the event on the element
                      element.dispatchEvent(event);
                    }
                  }
                setTimeout(() => {
                    // console.log('change the price!');
                    simulateClick(pricingToggle);
                }, 500);

                pricingToggle.addEventListener("change", function (event) {
                    toggleMonthly(parsed, event)
                })
                
                pricingToggle.disabled = false;
            })
            .catch((error) => {
                console.log(error);
            });
    }
});

function updateStartingPrice(parsed, index = 0, frequency = false) {
    let pricingStructure = parsed[index].config.pricing_structure
    let prices = frequency ? pricingStructure.monthly : pricingStructure.single;
    // let prices;
    // if (!frequency) {
    //     prices = parsed[index].config.pricing_structure.single;
    // } else {
    //     prices = parsed[index].config.pricing_structure.monthly;        
    // }

    let priceMapping = [
        { selector: '.pricing.standard .price-value', value: prices[0].A}, 
        { selector: '.pricing.premium .price-value', value: prices[1].AA}, 
        { selector: '.pricing.pro .price-value', value: prices[2].AAA}, 
    ]

    priceMapping.forEach(price => {
        document.querySelector(`${price.selector}`).innerHTML = `$${price.value}`;
    })
    
    

    // let singleAP = "$" + prices[0].A;
    // let doubleAP = "$" + prices[1].AA;
    // let TripleAP = "$" + prices[2].AAA;

    // let standard = document.querySelector('.pricing.standard .price-value')
    // let premium = document.querySelector('.pricing.premium .price-value')
    // let pro = document.querySelector('.pricing.pro .price-value')

    // standard.innerHTML = singleAP;
    // premium.innerHTML = doubleAP;
    // pro.innerHTML = TripleAP;
}

function updatePricing(parsed) {
    // console.log('parsed parsed parsed')
    // console.log(parsed)
    // let pricing
    let select = document.getElementById('package-levels-dropdown')
    let checked = document.getElementById('pricing-toggle-checkbox').checked;
    // let toggle = document.getElementById('pricing-toggle-checkbox');    

    // using the nullish coalescing operator (??), which checks if select is null or undefined and assigns it the value
    // select = select ?? document.getElementById('input_5_30')TODO: update when the JS/gulp is updated
    if (typeof select == 'undefined' || select == null) {
        select = document.getElementById('input_5_30')
    }

    let option = select.options[select.selectedIndex]
    let order = option.dataset.order
    // order = order ?? 0 // TODO: update when the JS/gulp is updated
    if (order == undefined) {
        order = 0;
    }

    // console.log('order order order')
    // console.log(order)

    let pricingStructure = parsed[order].config.pricing_structure;
    let prices = checked ? pricingStructure.monthly : pricingStructure.single;
    // let prices;
    // if (checked) {
    //     prices = pricingStructure.monthly;
    // } else {
    //     prices = pricingStructure.single;
    // }

    // let singleAP = pricing[0].A;
    // let doubleAP = pricing[1].AA;
    // let TripleAP = pricing[2].AAA;

    // add dollar sign to all options below 4 cause 4 have a value of "Call for Quote"
    // if (order <= 3) {
    //     singleAP = "$" + singleAP;
    //     doubleAP = "$" + doubleAP;
    //     TripleAP = "$" + TripleAP;
    // }

    let priceMapping = [
        { selector: '.pricing.standard .price-value', value: prices[0].A}, 
        { selector: '.pricing.premium .price-value', value: prices[1].AA}, 
        { selector: '.pricing.pro .price-value', value: prices[2].AAA}, 
    ]

    priceMapping.forEach(price => {
        let formattedPrice = order <= 3 ? `$${price.value}` :  "Call for Quote" // price.value; TODO: if updating to use pricing for all packages, change this for the Gravity form pricing
        document.querySelector(price.selector).innerHTML = formattedPrice;
        // if (order <= 3) {
        //     document.querySelector(price.selector).innerHTML = `$${price.value}`;
        // } else {
        //     document.querySelector(price.selector).innerHTML = price.value;
        // }
    })

    // let standard = document.querySelector('.pricing.standard .price-value')
    // let premium = document.querySelector('.pricing.premium .price-value')
    // let pro = document.querySelector('.pricing.pro .price-value')

    // standard.innerHTML = singleAP;
    // premium.innerHTML = doubleAP;
    // pro.innerHTML = TripleAP;
    // console.log(pricing)
}

function createDropdownOptions(parsed) {
    let dropdown = document.getElementById('package-levels-dropdown')

    parsed.forEach(e => {
        let opt = document.createElement('option');
        opt.text = e.title;
        opt.value = e.id;
        opt.dataset.order = e.config.sort_order;
        dropdown.options.add(opt)
    });

    dropdown.addEventListener('change', function () {
        updatePricing(parsed)
    })
}

function toggleMonthly(parsed, event) {
    let elem = event.target;
    let containers = document.querySelectorAll(".pricing-container");
    let pricingTitle = document.querySelector(".pricing-title-toggle");
    // console.log(elem.checked)
    displayMonthlyInPrice(elem.checked)


    containers.forEach(element => {
        if (elem.checked) {
            element.classList.add('monthly')
        } else {
            element.classList.remove('monthly')
        }
    });

    if(pricingTitle.innerHTML === "Pricing for a Single Scan") {
        pricingTitle.innerHTML = "Pricing for Monthly Scans"
    } else {
        pricingTitle.innerHTML = "Pricing for a Single Scan"
    }

    updatePricing(parsed)
}

function displayMonthlyInPrice(checked) {
    let elem = document.querySelectorAll('.monthly-indicator');

    if (checked) {
        elem.forEach(element => {
            element.classList.remove('hide')
        });
    } else {
        elem.forEach(element => {
            element.classList.add('hide')
        });
    }
}


function postToAdminAjax(action, data = {}) {
    return new Promise((resolve, reject) => {
        data.action = action;

        jQuery.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: data,
            success: function (response) {
                resolve(response);
            },
            error: function (xhr, ajaxOptions, errorMessage) {
                reject(new Error(errorMessage));
                console.log("ERROR:" + errorMessage);
            }
        });
    })
}

function getAdminAjax(action, data = {}) {
    return new Promise((resolve, reject) => {
        data.action = action;

        jQuery.ajax({
            type: "GET",
            url: "/wp-admin/admin-ajax.php",
            data: data,
            success: function (response) {
                resolve(response);
            },
            error: function (xhr, ajaxOptions, errorMessage) {
                reject(new Error(errorMessage));
                console.log("ERROR:" + errorMessage);
            }
        });
    })
}
